<template>
  <button class="flex items-start gap-1 pl-2.5 py-1 pr-1 rounded-md transition-colors duration-100"
  :class="isEditing ? 'box-container-active' : 'box-container'"
  @click="$emit('selected')">
    <div class="flex items-center gap-1 flex-wrap">
      <div v-for="(condition, index) in filterConditions" :key="condition.renderKey" class="flex items-center">
        <BaseText v-if="index > 0" type="label" size="sm" class="text-text-normal bg-background-normal mr-2 whitespace-nowrap px-1.5 py-0.5 rounded-md">
          or
        </BaseText>
        <BaseText type="label" size="sm" class="text-text-muted mr-1 whitespace-nowrap">
          {{ condition.property.name }}
        </BaseText>
        <BaseText type="label" size="sm" class="text-text-normal bg-background-normal mr-1 whitespace-nowrap px-1.5 py-0.5 rounded-md">
          {{ condition.operation.name }}
        </BaseText>
        <BaseText type="label" size="sm" class="value-text text-text-muted" :class="{'mr-2': index < filterConditions.length - 1}">
          {{ getConditionValueText(condition) }}
        </BaseText>
      </div>
    </div>
    <button class="w-6 h-6 flex items-center justify-center transition-colors duration-100 hover:bg-neutral-25 flex-shrink-0"
    style="border-radius: 4px;" @click.stop="$emit('remove')">
      <TagRemoveIcon class="text-icon-normal" :width="18" :height="18" />
    </button>
  </button>
</template>

<script>
import TagRemoveIcon from '../../globals/Icons/TagRemoveIcon.vue'

export default {
  name: 'AppliedFilter',
  components: {
    TagRemoveIcon
  },
  props: {
    filterConditions: {
      type: Array,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    currencyRegion: {
      type: String,
      default: 'USD'
    }
  },
  computed: {
    currencySymbol() {
      return new Intl.NumberFormat('en', { 
        style: 'currency', 
        currency: this.currencyRegion,
        currencyDisplay: 'symbol' 
      }).format(0).charAt(0)
    }
  },
  methods: {
    getConditionValueText(condition) {
      const conditionValueType = condition.operation?.optionInputOverride?.type
        ?? condition.property?.input?.type
        ?? 'text'

      if (conditionValueType === 'dropdown') {
        return condition.property.input.options.find(option => option.value === condition.value)?.name || condition.value
      } else if (conditionValueType === 'relative_date') {
        return `last ${condition.value} days`
      }
      return this.formatConditionValue(condition.value, conditionValueType)
    },
    formatConditionValue(value, type) {
      if (type === 'currency') {
        const hasDecimal = value.toString().includes('.')
        const fixedValue = value.toLocaleString(undefined, {
          maximumFractionDigits: 2,
          minimumFractionDigits: hasDecimal ? 2 : 0
        })
        return `${this.currencySymbol}${fixedValue}`
      } else if (type === 'number') {
        return value.toLocaleString()
      } else if (type === 'percent') {
        const formattedDecimal = new Intl.NumberFormat(navigator?.language || 'en-US', {
          style: 'decimal',
          maximumFractionDigits: 5
        }).format(value)
        return `${formattedDecimal}%`
      } else if (type === 'time') {
        const minutes = Math.floor(value / 60)
        const remainingSeconds = value % 60
        return `${minutes.toString().padStart(1, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
      } else if (type === 'text') {
        return `"${value}"`
      }
      return value
    }
  }
}
</script>

<style scoped>
.value-text {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-container{
  box-shadow: 0px 0px 0px 1px #12376914, 0px 1px 2px 0px #12376914;
}
.box-container:hover,
.box-container-active {
  box-shadow: 0px 1px 2px 0px rgba(0, 56, 108, 0.1), 0px 0px 0px 1px rgba(0, 56, 108, 0.1);
}
</style>
